import { Agency } from '../model/agency';
import { AgencyList } from '../model/agency-list';
export class AgencyBuilder {
    static buildAgency(data) {
        const agency = new Agency();
        agency.id = data.id;
        agency.id_group = data.id_group;
        agency.name = data.name;
        agency.company_name = data.company_name;
        agency.contact_name = data.contact_name;
        agency.contact_email = data.contact_email;
        agency.address = data.address;
        agency.city = data.city;
        agency.state = data.state;
        agency.phone_1 = data.phone_1;
        agency.phone_2 = data.phone_2;
        agency.fax = data.fax;
        agency.alias = data.alias;
        agency.password = data.password;
        agency.code = data.code;
        agency.email = data.email;
        agency.email_reservations = data.email_reservations;
        agency.payment_extra = data.payment_extra;
        agency.payment_number = data.payment_number;
        agency.zip = data.zip;
        agency.nif = data.nif;
        agency.send_info_mails = data.send_info_mails;
        agency.payment_mode = data.payment_mode;
        agency.use_name_prefix = data.use_name_prefix;
        agency.hash = data.hash;
        agency.group_name = data.group_name;
        agency.active = data.active;
        agency.notes = data.notes;
        agency.a3_account = data.a3_account;
        agency.group = data.group;
        return agency;
    }
    static buildAgencyList(data) {
        const agencies = new AgencyList();
        agencies.page = data.page;
        agencies.pagination = data.pagination;
        agencies.total = data.total;
        agencies.agencies = _.map(data.agencies, (agency) => {
            return AgencyBuilder.buildAgency(agency);
        });
        return agencies;
    }
}
//# sourceMappingURL=agency-builder.js.map